import * as React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export interface AccordionProps {
  AccordionHeader?: JSX.Element;
  className?: string;
}

const { useState } = React;

const Accordion: React.FC<React.PropsWithChildren<AccordionProps>> = ({ children, AccordionHeader, className }) => {
  const [isOpen, setExpand] = useState(false);

  const handleToggle = () => {
    setExpand(!isOpen);
  };

  return (
    <section className={className}>
      <div onClick={handleToggle} data-is-open={isOpen}>
        {AccordionHeader}
      </div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: 'auto', opacity: 1 },
              collapsed: { height: 0, opacity: 0 },
            }}
            transition={{ duration: 0.2 }}
          >
            {children}
          </motion.section>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Accordion;
